import { createContext, useContext, useState } from "react";

const PartidoContext = createContext(null);

export const PartidoProvider = ({ children }) => {
  const [selectedPartido, setSelectedPartido] = useState(null);
  return (
    <PartidoContext.Provider value={{ selectedPartido, setSelectedPartido }}>
      {children}
    </PartidoContext.Provider>
  );
};

export const usePartido = () => useContext(PartidoContext);
